export enum Services {
  Remittance = 'REMITTANCE',
  Topup = 'TOP-UP',
  Sms = 'MESSAGE',
  Nauta = 'NAUTA',
  Delivery = 'DELIVERY',
  RentalCar = 'RENTAL_CAR',
}
